//SHARED FILE : USED ON DETAILS AND PRODUCT LIST
//ANY CHANGES SHOULD BE TESTED ON BOTH PAGES
$(function(){
	//idea board
      $('#faveLink').on('click', function(e) {
		e.preventDefault();
		$('#ideaBoardList').css({ 'z-index' : '1000', 'top' : '270px', 'width' : '290px'}).slideDown('fast');
	}); 
	
	$('#faveLink').on('keypress', function(e) {
		if(e.which == 13){
 			$(this).click();
	 	}
	});
	
	$('#cancelBoardList').on('click', function(e) {
		e.preventDefault();
		$('#ideaBoardList').slideUp('fast');
		$('.addToBoardMsg').each(function(){
			$(this).remove();
		});
	});
	
	$('#cancelBoardList').on('keypress', function(e) {
		if(e.which == 13){
 			$(this).click();
	 	}
	});
	
	 $('.boardName').on('click', function(e) {
		e.preventDefault();
		$(this).siblings('.addToBoardMsg').slideUp('fast').remove();
		AddToIdeaBoard(this);
	});
	
	$('.boardName').on('keypress', function(e) {
		if(e.which == 13){
 			$(this).click();
	 	}
	}); 
	
	$('body').on('click', '.cancel-delete-item', function(e) {
		e.preventDefault();
		$(this).closest('.addToBoardMsg').slideUp('fast').remove();
	});
	
	$('body').on('keypress', ' .cancel-delete-item',  function(e) {
		if(e.which == 13){
 			$(this).click();
	 	}
	});
	
	$('body').on('click', '.confirm-delete-item', function(e) {
		e.preventDefault();
		var arr = $(this).attr('href').split('/');
		DeleteBoardItem(arr[0], arr[1], this);
	});
	
	$('body').on('keypress', '.confirm-delete-item', function(e) {
		if(e.which == 13){
 			$(this).click();
	 	}
	});	
	//end idea board

    //add to idea board
    function AddToIdeaBoard(e){
       d = $(e).siblings('.board-id').val();
    	var data = { boardID: d, productID: prodID };
        $.ajax({
            url: "/favs/additemtoboard",
            type: "POST",
            data: JSON.stringify(data),
            beforeSend: function (req) {
                $(e).siblings('.addItemLoading').fadeIn('fast');
            },
            complete: function (req) {
                $(e).siblings('.addItemLoading').fadeOut('fast');
            },
            contentType: 'application/json',
            dataType: 'json',
            success: function (result) {
                //If the user is able to place a sample request display the sample request form otherwise let them know when they are not able to.
                $(e).after((result.message));
                if(result.success == "true"){
                	$('#faveLink').removeClass('textDkGray').addClass('textRed');
                }
            }
        });
    }
    
    function DeleteBoardItem(e, f, g){
	var boardID = e;
	var boardItemID = f;	
	var data = {	boardID: boardID, boardItemID : boardItemID };
	
	$.ajax({
            url: '/favs/deleteboarditem',
            type: "POST",
            data: JSON.stringify(data),
            dataType: 'json',
            contentType: "application/json",
            beforeSend: function () {
                $(g).siblings('.addItemLoading').fadeIn('fast');
            },
            complete: function(result){
            	   $(g).siblings('.addItemLoading').fadeOut('fast');
            },
            success: function (result) { 
                	$(g).closest('.addToBoardMsg').slideUp('fast').remove();
                	if(result.isItemInOtherBoards == "False"){
                		$('#faveLink').removeClass('textRed').addClass('textDkGray');
                	}
            },           
            error: function (result) {
               
            }
       });
    }
    //end add to idea board
});